"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var StyledIconButton = (0, styles_1.styled)(IconButton_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.MuiIconButton-colorError"] = {
            color: theme.palette.grey[600],
            background: theme.palette.grey[100]
        },
        _b["&.MuiIconButton-colorError:hover"] = {
            color: theme.palette.error.main,
        },
        _b[".MuiSvgIcon-root"] = {
            transform: 'scale(0.8)'
        },
        _b);
});
exports.default = StyledIconButton;
